var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-box',{attrs:{"tag":"legend","display":"block","w":"full","mb":"6","pb":"1","font-size":"xl","font-weigth":"semi-bold","color":"primary","border-b":"","border-color":"gray-400"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }